import API from '../../../lib/commons/api'

export type BusinessClientDto = {
  uuid: string
  displayName: string
  officialName: string
}

// Fetch-all uses a high limit so every record comes back in a single request.
const FIND_ALL_LIMIT = 2000

export const findBusinessClients = async (): Promise<BusinessClientDto[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/business_clients/find',
    { name: '', limit: FIND_ALL_LIMIT },
    true
  )
  return (response.json?.data ?? []) as BusinessClientDto[]
}
